export default "__VITE_ASSET__BGbXeACr__"